import {combineReducers} from "redux";
import transferWithAmount from "./amount";
import percentage from "./percentage";

const transferReducer = combineReducers({
    transferWithAmount,percentage
});
export default transferReducer;
